import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { LoadingBackDrop } from "../../../../components/loader";
import { useAppDispatch } from "../../../../hooks/redux-hooks";
import { auth, warehouses } from "../../../../redux/actions";
import { getOrdersPricelistOffersById } from "../../../../services/orders/pricelist-offers-get-by-id";
import { PricelistOffersGetByIdPayload } from "../../../../services/orders/pricelist-offers-get-by-id/types";
import SessionService from "../../../../services/session-service";
import { getAllWarehouses } from "../../../../services/warehouses/get-all";
import { OfferView } from "../../offer-view";
import { OfferHasBeenFinallyAccepted } from "../../offer-view/components/view-variants/offer-has-been-finally-accepted-or-no-offer-to-final-accept";
import { statusChandleDataFinalOffer } from "../helpers/pre-selection-data";
import {
  OfferViewComponent,
  StatusChandleDataResponse,
} from "../helpers/types";
import { UserRoles } from "../../../../types/user-roles";
import AccessDenied from "../../../common-views/access-denied/access-denied";

export const FinalOfferFromEmailClientLogged = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const [userRole, setUserRole] = useState<UserRoles>(
    SessionService.getUser() !== null &&
      SessionService.getUser().typ_uzytkownika
  );
  const isOfferPrepated: boolean = SessionService.getFinalOfferForAccepance()
    ? SessionService.getFinalOfferForAccepance().emailHasBeenSent
    : false;

  const [preOrdersPricelist, setPreOrdersPricelist] =
    useState<PricelistOffersGetByIdPayload>();
  const [preSelectionData, setPreSelectionData] =
    useState<StatusChandleDataResponse>();

  const body = {
    paginacja: null,
  };
  const getAllWarehousesClient = useQuery(
    ["warehouses"],
    () => getAllWarehouses(body),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        dispatch(warehouses.fetchAllWarehouses(data.data.payload.magazyny));
        SessionService.setWarehousesList(data.data.payload.magazyny);
      },
    }
  );

  const getOrdersPricelistOffersByIdMutation = useMutation(
    getOrdersPricelistOffersById,
    {
      onSuccess: (res) => {
        SessionService.clearFinalOfferForAccepance();
        setPreSelectionData(statusChandleDataFinalOffer(res.data?.payload));
        const newRes: PricelistOffersGetByIdPayload = {
          id_zamowienie: res.data.payload.id_zamowienie,
          numer_zamowienia: res.data.payload.numer_zamowienia,
          data_zlozenia: res.data.payload.data_zlozenia,
          status_zamowienia: res.data.payload.status_zamowienia,
          opis_uslugi: res.data.payload.opis_uslugi,
          termin_rozpoczecia: res.data.payload.termin_rozpoczecia,
          termin_zakonczenia: res.data.payload.termin_zakonczenia,
          kraj: res.data.payload.kraj,
          wojewodztwo: res.data.payload.wojewodztwo,
          kod_pocztowy: res.data.payload.kod_pocztowy,
          miasto: res.data.payload.miasto,
          miejsce: res.data.payload.miejsce,
          skladowanie_plaskie: res.data.payload.skladowanie_plaskie,
          wysokie_skladowanie: res.data.payload.wysokie_skladowanie,
          polki: res.data.payload.polki,
          warunek_temperaturowy: res.data.payload.warunek_temperaturowy,
          rodzaj_towaru: res.data.payload.rodzaj_towaru,
          opis_towaru: res.data.payload.opis_towaru,
          specjalny_sprzet: res.data.payload.specjalny_sprzet,
          dodatkowe_uwagi: res.data.payload.dodatkowe_uwagi,
          oferty: statusChandleDataFinalOffer(res.data?.payload).data,
          uslugi_zamowione: {
            cel_zamowienia: res.data.payload.uslugi_zamowione.cel_zamowienia,
            uslugi_dodatkowe:
              res.data.payload.uslugi_zamowione.uslugi_dodatkowe,
            ilosc_dodatkowych:
              res.data.payload.uslugi_zamowione.ilosc_dodatkowych,
            uslugi_zamowione_id:
              res.data.payload.uslugi_zamowione.uslugi_zamowione_id,
          },
        };
        setPreOrdersPricelist(newRes);
      },
      onError: (err: any) => {},
    }
  );

  useEffect(() => {
    if (!isOfferPrepated) {
      //Wymusza wylogowanie aktualnego użytkownika
      {
        SessionService.clearUserSession();
        SessionService.clearLoggedUserData();
        dispatch(auth.userLogout());
        navigate("/login");
      }

      SessionService.setFinalOfferForAccepance({
        emailHasBeenSent: true,
        id: `${id}`,
      });
      navigate("/login");
    } else
      getOrdersPricelistOffersByIdMutation.mutate({
        id_zamowienie: id,
        token: null,
      });
  }, []);

  if (getAllWarehousesClient.isLoading || preSelectionData === undefined) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      {userRole === UserRoles.CLIENT ? (
        preSelectionData?.view === OfferViewComponent.finalOffertView ? (
          <OfferView
            offer_id_from_email={id}
            data={preOrdersPricelist}
            isFinalOffer={true}
          />
        ) : (
          <OfferHasBeenFinallyAccepted />
        )
      ) : (
        <AccessDenied />
      )}
    </>
  );
};
